import { ProductQty, SelectedItemMap } from '@common/models';
import { productQtyFromSelectedItems } from '@common/utils/productQtyFromSelectedItems';

// TODO: consolidate with getCutoutsProductQty
export const getFaucetsProductQty = (faucets: SelectedItemMap): ProductQty[] => productQtyFromSelectedItems(faucets);
